import { useState, useEffect } from "react";
import Button from "../../../../Core/Button/Button";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import SelectMultiSearch from "../../../../Core/Fields/Floating/SelectMultiSearch";
import Date from "../../../../Core/Fields/Floating/Date";

const CartFilterPopup = ({
  show,
  onClose,
  filters,
  setFilters,
  cardType,
  statusOptions = [],
  defaultStatus = []
}) => {
  // fallback for when no statusOptions are passed
  const allfilterFallback = [
    { label: "Draft", value: "Draft" },
    { label: "On Hold", value: "On Hold" },
    { label: "To Deliver and Bill", value: "To Deliver and Bill" },
    { label: "To Bill", value: "To Bill" },
    { label: "To Deliver", value: "To Deliver" },
    { label: "Completed", value: "Completed" },
    { label: "Cancelled", value: "Cancelled" },
    { label: "Closed", value: "Closed" },
    { label: "Partially Receipt", value: "Partially Receipt" },
    { label: "Completely Receipt", value: "Completely Receipt" },
    { label: "Confirmed For Submitted", value: "Confirmed For Submitted" }
  ];

  const providedStatusOptions = statusOptions && statusOptions.length ? statusOptions : allfilterFallback;

  const defaultTimeInterval =
    cardType === "Sales_Order_to_Bill" ||
    cardType === "Sales_Order_to_Deliver"
      ? "Weekly"
      : "Monthly";

  // Local UI state
  const [localFilters, setLocalFilters] = useState({
    dateFilters: [
      { label: "From Date", value: "" },
      { label: "To Date", value: "" }
    ],
    timeInterval: defaultTimeInterval,
    statusFilters: defaultStatus && defaultStatus.length ? [...defaultStatus] : [],
    wmsStatusFilters: []
  });

  const timeIntervalOptions = [
    { label: "Daily", value: "Daily" },
    { label: "Weekly", value: "Weekly" },
    { label: "Monthly", value: "Monthly" },
    { label: "Yearly", value: "Yearly" }
  ];

  // Restore state when popup opens
  useEffect(() => {
    if (!show) return;

    setLocalFilters({
      dateFilters:
        filters && filters.dateFilters
          ? [...filters.dateFilters]
          : [
              { label: "From Date", value: "" },
              { label: "To Date", value: "" }
            ],
      timeInterval:
        filters && filters.timeInterval
          ? filters.timeInterval
          : defaultTimeInterval,
      statusFilters:
        filters && filters.statusFilters
          ? [...filters.statusFilters]
          : defaultStatus && defaultStatus.length
          ? [...defaultStatus]
          : [],
      wmsStatusFilters:
        filters && filters.wms_status ? [...filters.wms_status] : []
    });
  }, [show, filters, cardType, defaultStatus]);

  const handleDateChange = (index, value) => {
    const updated = [...localFilters.dateFilters];
    updated[index] = { ...updated[index], value };
    setLocalFilters((prev) => ({ ...prev, dateFilters: updated }));
  };

  const handleTimeIntervalChange = (value) => {
    setLocalFilters((prev) => ({ ...prev, timeInterval: value }));
  };

  const handleStatusChange = (values) => {
    const wmsSpecialStatuses = [
      "Partially Receipt",
      "Completely Receipt",
      "Confirmed For Submitted"
    ];

    const wmsStatuses = values.filter((s) => wmsSpecialStatuses.includes(s));
    const normalStatuses = values.filter(
      (s) => !wmsSpecialStatuses.includes(s)
    );

    setLocalFilters((prev) => ({
      ...prev,
      statusFilters: normalStatuses,
      wmsStatusFilters: wmsStatuses
    }));
  };

  const handleApply = () => {
    const completeFilters = {
      dateFilters: localFilters.dateFilters,
      timeInterval: localFilters.timeInterval,
      statusFilters: localFilters.statusFilters,
      wms_status: localFilters.wmsStatusFilters
    };

    setFilters(completeFilters);
    onClose();
  };

  const handleReset = () => {
    setLocalFilters({
      dateFilters: [
        { label: "From Date", value: "" },
        { label: "To Date", value: "" }
      ],
      timeInterval: defaultTimeInterval,
      statusFilters: defaultStatus && defaultStatus.length ? [...defaultStatus] : [],
      wmsStatusFilters: []
    });
  };

  if (!show) return null;

  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-md"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header py-2">
            <h5 className="modal-title" style={{ fontSize: "17.5px" }}>
              Filter
            </h5>
            <button
              type="button"
              style={{ fontSize: "11px" }}
              className="btn-close"
              onClick={onClose}
            />
          </div>

          <div className="modal-body">
            <div className="row mb-3">
              <div className="col-md-6">
                <Date
                  id="fromDate"
                  label="Filter From Date"
                  value={localFilters.dateFilters[0]?.value || ""}
                  onChange={(e) => handleDateChange(0, e.target.value)}
                />
              </div>
              <div className="col-md-6">
                <Date
                  id="toDate"
                  label="Filter To Date"
                  min={localFilters.dateFilters[0]?.value}
                  value={localFilters.dateFilters[1]?.value || ""}
                  onChange={(e) => handleDateChange(1, e.target.value)}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <SelectSearch
                  list={timeIntervalOptions}
                  label="Time Interval"
                  getOptionLabel={(item) => item.label}
                  getOptionValue={(item) => item.value}
                  value={localFilters.timeInterval}
                  onChange={handleTimeIntervalChange}
                />
              </div>

              {statusOptions.length > 0 && (
                <div className="col-md-6">
                  <SelectMultiSearch
                    label="Status"
                    options={providedStatusOptions}
                    // Merge back both arrays for the UI display
                    value={[
                      ...localFilters.statusFilters,
                      ...localFilters.wmsStatusFilters
                    ]}
                    onChange={handleStatusChange}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="modal-footer">
            <Button className="custom-btn-9898970" onClick={handleReset}>
              Reset
            </Button>

            <Button className="custom-btn-00989" onClick={handleApply}>
              Apply
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartFilterPopup;
